import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ViewEncapsulation,
} from '@angular/core';
import {
    AuthService,
    UserInterface,
    ResponsiveUtilitesService,
} from '../../../core';
import { Observable, BehaviorSubject } from 'rxjs';

@Component({
    selector: 'solis-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class NavbarComponent implements OnInit {
    user$: Observable<UserInterface>;
    layout$: Observable<string>;
    fluid$: Observable<boolean>;
    isNavbarOpen$: Observable<boolean>;
    canBeAdjustable$: BehaviorSubject<any>;

    constructor(
        private authService: AuthService,
        private responsiveUtilitiesService: ResponsiveUtilitesService,
    ) {
        this.user$ = this.authService.currentUser;

        this.user$.subscribe(user => {
            if (!user) {
                this.authService.purgeAuth();
            }
        });
    }

    ngOnInit() {
        this.layout$ = this.responsiveUtilitiesService.layout$;
        this.fluid$ = this.responsiveUtilitiesService.fluid$;
        this.isNavbarOpen$ = this.responsiveUtilitiesService.isNavbarOpen$;
        this.canBeAdjustable$ = this.responsiveUtilitiesService.canBeAdjustable$;
    }

    logout() {
        this.authService.purgeAuth();
    }

    toggleLayout(): void {
        window.localStorage.setItem(
            'layout',
            this.responsiveUtilitiesService.layout$.getValue() === 'list'
                ? 'grid'
                : 'list',
        );

        switch (this.responsiveUtilitiesService.canBeAdjustable$.getValue()) {
            case true:
                if (
                    this.responsiveUtilitiesService.layout$.getValue() ===
                    'list'
                ) {
                    this.responsiveUtilitiesService.layout$.next('grid');
                    // this.setFluid(false);
                } else {
                    this.responsiveUtilitiesService.layout$.next('list');
                    // this.setFluid(true);
                }
                break;

            case false:
                this.responsiveUtilitiesService.layout$.next('grid');
                break;

            case 'half':
                if (
                    this.responsiveUtilitiesService.layout$.getValue() ===
                    'list'
                ) {
                    this.responsiveUtilitiesService.layout$.next('grid');
                    // this.toggleFluid();
                } else {
                    this.responsiveUtilitiesService.layout$.next('list');
                    // this.toggleFluid();
                }
                break;
        }
    }

    setFluid(bool): void {
        window.localStorage.setItem('fluid', bool === true ? 'true' : 'false');

        this.responsiveUtilitiesService.fluid$.next(bool);
    }

    toggleFluid(): void {
        window.localStorage.setItem(
            'fluid',
            this.responsiveUtilitiesService.fluid$.getValue()
                ? 'false'
                : 'true',
        );

        this.responsiveUtilitiesService.fluid$.getValue()
            ? this.responsiveUtilitiesService.fluid$.next(false)
            : this.responsiveUtilitiesService.fluid$.next(true);
    }

    toggleNavbar(): void {
        window.localStorage.setItem(
            'isNavbarOpen',
            this.responsiveUtilitiesService.isNavbarOpen$.getValue()
                ? 'false'
                : 'true',
        );

        this.responsiveUtilitiesService.isNavbarOpen$.getValue()
            ? this.responsiveUtilitiesService.isNavbarOpen$.next(false)
            : this.responsiveUtilitiesService.isNavbarOpen$.next(true);
    }

    closeNavbar(): void {
        window.localStorage.setItem('isNavbarOpen', 'false');
        this.responsiveUtilitiesService.isNavbarOpen$.next(false);
    }
}
